import { axios } from '$app-web/api/axios';
import { Room } from '$app-web/types/chat';

import { Endpoints } from '../constant';

export async function fetchParticipantResearcherChatRooms(studyId: number) {
    try {
        const params = { study_id: studyId };
        const { data } = await axios.get<Array<Room>>(Endpoints.Chat.Rooms, { params });

        return data;
    } catch {
        throw new Error('Failed to fetch participant researcher room');
    }
}
